function isV2QueryParamEnabled() {
  const queryParams = new URL(window.location).searchParams;
  return queryParams.get('v2') === 'enabled';
}

function isOptimizelyV2OverrideEnabled() {
  return !!window.susie;
}

function versionSwitch() {
  const isV2Enabled =
    isOptimizelyV2OverrideEnabled() || isV2QueryParamEnabled();

  var versionString = isV2Enabled ? 'V2' : '';

  var scriptElement = document.createElement('script');
  scriptElement.type = 'text/javascript';
  scriptElement.src = `${ASSET_VERSIONED_URL}/login${versionString}${ASSET_FILENAME_SUFFIX}.js`;

  document.head.appendChild(scriptElement);
}

versionSwitch();
